import React, { useState, useContext } from 'react';
import axios from 'axios';
import styles from './ResetPassword.module.css';
import logo1 from "../../assets/logo1.png";
import { LanguageContext } from "../../Component/LanguageContext/LanguageContext";

function ResetPassword() {
  const { direction } = useContext(LanguageContext);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [emailId, setEmailId] = useState('');
  const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    try {
      const response = await axios.post(`${marketingBackendUrl}/maflam/request-password-reset`, { emailId });
      setMessage(response.data.message);
      alert(response.data.message);
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Error requesting password reset';
      const translatedErrorMessage = direction === "rtl" ? "خطأ في طلب إعادة تعيين كلمة المرور" : errorMessage;
      setError(translatedErrorMessage);
      alert(translatedErrorMessage);
    }
  };

  // Handle resend functionality by calling the submit function again
  const handleResend = (event) => {
    event.preventDefault();  // Prevent default link behavior
    handleSubmit(event);  // Call the handleSubmit function to resend the request
  };

  return (
    <>
      <div className={styles.maincontainer} style={{ direction: direction }}>
        <div className={styles.secondcontainer}> 
          <header className={styles.header}>
            <img src={logo1} alt="resetlogo" className={styles.resetlogo} />
            <h1>{direction === "rtl" ? "إعادة تعيين كلمة المرور" : "Reset Password"}</h1>
          </header>

          <form className={styles.form} onSubmit={handleSubmit}>
            <label htmlFor="email">{direction === "rtl" ? "البريد الإلكتروني" : "Email"}</label>
            <input 
              type="email" 
              id="email" 
              name="email" 
              value={emailId}
              onChange={(e) => setEmailId(e.target.value)} 
              placeholder={direction === "rtl" ? "بريدك الإلكتروني@gmail.com" : "Youremail@gmail.com"} 
              className={styles.input} 
              required
            />

            <button 
              type="submit" 
              className={styles.submitButton}
            >
              {direction === "rtl" ? "طلب إعادة تعيين كلمة المرور" : "Request Password Reset"}
            </button>
            <p className={styles.resendText}>
              {direction === "rtl" ? "لم تستلم البريد؟" : "Didn't receive the mail?"} &nbsp;
              <a 
                href="#" 
                className={styles.link} 
                onClick={handleResend}
              >
                {direction === "rtl" ? "إعادة الإرسال" : "Resend"}
              </a>
            </p>  
            {error && <p className={styles.error}>{error}</p>}
          </form>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
